window.bootstrap = require('bootstrap');
window.Popper = require('@popperjs/core');
window.$ = window.jQuery = require('jquery');
window.TomSelect = require('tom-select').default;

$.ajaxSetup({
    headers: {
        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content'),
    },
});

$(function () {
    let $formReservation = $('#form-reservation');
    let $fServiceCategory = $('#f-service-category');
    let $selectServiceCategory = $formReservation.find('select[name="service_category"]');
    let $fService = $('#f-service');
    let $fType = $('#f-type-eyelash');
    let $fRemove = $('#f-remove-eyelash');
    let $fIsPreferredStaff = $('#f-is-preferred-staff');
    let $selectIsPreferredStaff = $('select[name="is_preferred_staff"]');
    let $fPreferredStaff = $('#f-preferred-staff');
    let $selectPreferredStaff = $('select[name="preferred_staff_id"]');
    let $fDate = $('#f-date');
    let $inputDate = $formReservation.find('input[name="date"]');
    let $fTime = $('#f-time');
    let $ulTimes = $('.ul-times');
    let $btnSubmit = $formReservation.find('button[type="submit"]');
    const submitButtonText = $btnSubmit.text();
    let isSubmitting = false;
    let isBooking = true;
    let isEyelash = false; //美睫
    let isFacialCare = false; //臉部保養
    let isPreferredStaff = false;
    let preferredStaffId = null;
    let maxServices = 1;

    initReservationPage();

    //服務項目
    $selectServiceCategory.on('change', function () {
        let value = $(this).val();
        let $option = $(this).find('option:selected');

        if ($option.data('hint')) {
            $fServiceCategory.find('.hint').text($option.data('hint'));
        } else {
            $fServiceCategory.find('.hint').text('');
        }

        isBooking = true;

        if ($option.data('slug') == 'eyelash') {
            isEyelash = true;
            isFacialCare = false;
        } else if ($option.data('slug') == 'facial-care') {
            isEyelash = false;
            isFacialCare = true;
        } else {
            isEyelash = false;
            isFacialCare = false;
            isPreferredStaff = false;
            resetPreferredStaff();
        }

        toggleFields();

        $.ajax({
            method: 'POST',
            url: '/get-services',
            data: {
                c: value,
            },
        }).done(function (data) {
            $fService.find('.wrapper').empty();

            maxServices = data.multiple ? data.multiple : 1;

            let $elem = $('<select class="form-select" name="services[]" id="service" required></select>');

            $.each(data.services, function (i, v) {
                $elem.append(
                    '<option value="' +
                        v.id +
                        '" data-hint="' +
                        v.description +
                        '" data-min="' +
                        v.minutes +
                        '" data-msg="' +
                        v.message +
                        '">' +
                        v.name +
                        '</option>',
                );
            });

            $fService.find('.wrapper').append($elem);

            if (maxServices > 1) {
                $elem.attr('multiple', 'multiple');
                $elem.val([]);

                new TomSelect($elem.get(0), {
                    plugins: ['remove_button'],
                    maxItems: maxServices,
                    placeholder: '請選擇',
                });
            }

            $fService.find('select[name^="services"]').trigger('change');
        });
    });

    $selectServiceCategory.trigger('change');

    //服務內容
    $(document).on('change', '#form-reservation select[name^="services"]', function () {
        isBooking = true;

        let $option = $(this).find('option:selected');

        if ($option.data('hint')) {
            $fService.find('.hint').text($option.data('hint'));
        } else {
            $fService.find('.hint').text('');
        }

        if ($option.data('min') === 0 && $option.data('msg')) {
            isBooking = false;
            toggleFields();
            alert($option.data('msg'));
            return false;
        }

        toggleFields();

        if (isPreferredStaff) {
            getAvailableStaff();
        }

        getAvailableTimes();
    });

    //指定座位
    $selectIsPreferredStaff.on('change', function () {
        let value = $(this).val();
        if (value === '1') {
            //需要
            isPreferredStaff = true;
        } else {
            isPreferredStaff = false;
            resetPreferredStaff();
        }

        toggleFields();

        if (isPreferredStaff) {
            getAvailableStaff();
        } else {
            getAvailableTimes();
        }
    });

    //選擇座位
    $selectPreferredStaff.on('change', function () {
        let value = $(this).val();
        preferredStaffId = value !== '' ? value : null;
        getAvailableTimes();
    });

    //選擇日期
    $inputDate.on('change', function () {
        getAvailableTimes();
    });

    $formReservation.on('submit', function (event) {
        if (isSubmitting) {
            event.preventDefault();
            return;
        }

        if (event.isDefaultPrevented()) {
            return;
        }

        isSubmitting = true;
        $btnSubmit.prop('disabled', true).text('處理中...');
    });

    // Restore the button when navigating back to a cached reservation page.
    $(window).on('pageshow', function (event) {
        if (event.originalEvent && event.originalEvent.persisted) {
            isSubmitting = false;
            $btnSubmit.prop('disabled', false).text(submitButtonText);
        }
    });

    function toggleFields() {
        if (!isBooking) {
            $fType.hide();
            $fRemove.hide();
            $fIsPreferredStaff.hide();
            $fPreferredStaff.hide();
            $selectPreferredStaff.prop('required', false);
            $fDate.hide();
            $fTime.hide();
            $btnSubmit.hide();
            return;
        }

        $fDate.show();
        $fTime.show();
        $btnSubmit.show();

        if (!isEyelash && !isFacialCare) {
            $fType.hide();
            $fRemove.hide();
            $fIsPreferredStaff.hide();
            $fPreferredStaff.hide();
            $selectPreferredStaff.prop('required', false);
            return;
        }

        if (isEyelash) {
            $fType.show();
            $fRemove.show();
        } else {
            $fType.hide();
            $fRemove.hide();
        }

        $fIsPreferredStaff.show();

        if (isPreferredStaff) {
            $fPreferredStaff.show();
            $selectPreferredStaff.prop('required', true);
        } else {
            $fPreferredStaff.hide();
            $selectPreferredStaff.prop('required', false);
        }
    }

    function resetPreferredStaff() {
        preferredStaffId = null;
        $selectIsPreferredStaff.val('0');
        $selectPreferredStaff.val('');
        $selectPreferredStaff.find('option').slice(1).remove();
        $fIsPreferredStaff.find('p').remove();
    }

    function getAvailableStaff() {
        let serviceIds = [];
        $fService
            .find('select[name^="services"] option')
            .filter(':selected')
            .each(function () {
                serviceIds.push($(this).val());
            });

        $fIsPreferredStaff.find('p').remove();
        $selectPreferredStaff.find('option').slice(1).remove();
        preferredStaffId = null;
        $selectPreferredStaff.val('');

        $.ajax({
            method: 'POST',
            url: '/get-available-staffs',
            data: {
                c: $selectServiceCategory.val(),
                s: serviceIds,
            },
        }).done(function (data) {
            if (data.staffs.length === 0) {
                $fIsPreferredStaff.append('<p>查無可用指定座位，請選擇其它預約項目或不指定座位。</p>');
                return;
            }

            $.each(data.staffs, function (index, val) {
                let room = val.room_name_alt ? val.room_name_alt : val.room_name ? val.room_name : val.name;
                let option = '<option value="' + val.id + '">' + room + '</option>';
                $selectPreferredStaff.append(option);
            });
        });
    }

    function getAvailableTimes() {
        let serviceIds = [];
        $fService
            .find('select[name^="services"] option')
            .filter(':selected')
            .each(function () {
                serviceIds.push($(this).val());
            });

        let date = $inputDate.val();

        $fTime.find('p').remove();
        $ulTimes.empty();

        if (serviceIds.length === 0) {
            return;
        }

        let staffId = isPreferredStaff && preferredStaffId ? preferredStaffId : null;

        $.ajax({
            method: 'POST',
            url: '/get-available-times',
            data: {
                c: $selectServiceCategory.val(),
                s: serviceIds,
                ps: staffId,
                d: date,
            },
        }).done(function (data) {
            $.each(data.slots, function (index, val) {
                $ulTimes.append(
                    '<li>' +
                        '<input type="radio" class="btn-check" name="booking" id="booking-' +
                        index +
                        '" autocomplete="off" value="' +
                        val.token +
                        '">' +
                        '<label for="booking-' +
                        index +
                        '">' +
                        val.time +
                        '</label>' +
                        '</li>',
                );
            });

            if (data.slots.length === 0) {
                $fTime.append('<p>查無可預約時段，請選擇其它預約日期或項目。</p>');
            }
        });
    }
});

async function initReservationPage() {
    const $loading = $('#loading');
    const $socialLogin = $('.social-login');
    const $formReservation = $('#form-reservation');
    const isLoggedIn = $('input[name="login"]').val() === '1';

    try {
        await liff.init({
            liffId: '2010297272-oiIYd2pF',
            withLoginOnExternalBrowser: false,
        });

        if (liff.isInClient()) {
            if (!liff.isLoggedIn()) {
                liff.login();
                return;
            }

            const idToken = liff.getIDToken();

            const loginResponse = await $.ajax({
                url: '/line/liff-login',
                method: 'POST',
                contentType: 'application/json',
                dataType: 'json',
                data: JSON.stringify({
                    id_token: idToken,
                }),
            });

            $loading.addClass('d-none');
            if (loginResponse.booking_suspended) {
                const reason = loginResponse.booking_suspension_reason
                    ? ' 原因：' + loginResponse.booking_suspension_reason
                    : '';
                $('#booking-suspended-message').removeClass('d-none').find('span').text(reason);
            } else {
                $formReservation.removeClass('d-none');
            }
            if (loginResponse.has_reservations) {
                $('#reservation-history-link').removeClass('d-none');
            }

            return;
        }

        if (isLoggedIn) {
            $loading.addClass('d-none');
            if ($formReservation.data('booking-suspended') !== 1) {
                $formReservation.removeClass('d-none');
            }
        } else {
            $loading.addClass('d-none');
            $socialLogin.css({
                display: 'flex',
            });
        }
    } catch (error) {
        let message = 'LINE 身分驗證失敗';

        if (error.responseJSON && error.responseJSON.message) {
            message = error.responseJSON.message;
        } else if (error.message) {
            message = error.message;
        }

        $loading.removeClass('d-none').addClass('loading-panel--error').text(message);
    }
}
